/** The pricing page. Plan text itself lives in plans.ts. */
export default {
  nav: {
    home: "Home",
  },
  eyebrow: "Pricing",
  title: "Simple plans, cinematic results",
  subtitle: "Start with 10 free points. Buy a points pack when you need more — a one-time payment, not a subscription.",
  creditsRemaining_one: "You have {{count}} point remaining",
  creditsRemaining_other: "You have {{count}} points remaining",
  mostPopular: "Most popular",
  secureCheckout: "Secure card checkout · One-time payment, no subscription · 30-day money-back guarantee",
  custom: {
    badge: "Custom pricing",
    title: "Build your own",
    intro:
      "Pick any amount between {{min}} and {{max}}. You get the benefits of the highest plan your amount reaches, and points at that plan's rate. From {{studio}}, you unlock Studio benefits.",
    priceLabel: "Your price (€)",
    summary_one: "For <amount>{{amount}}</amount> you get <credits>{{formatted}} point</credits> with {{level}} benefits.",
    summary_other: "For <amount>{{amount}}</amount> you get <credits>{{formatted}} points</credits> with {{level}} benefits.",
    credits: "Points",
    level: "Benefits level",
    included: "Included",
    cta: "Get started",
    errors: {
      invalid: "Enter an amount in euros, e.g. 25 or 25.50.",
      range: "Enter an amount between {{min}} and {{max}}.",
    },
  },
};
